import { getRecordings, setCompletedSubName } from 'actions/broadcast'
import { fetchScheduleFilterTeacherandStudent, fetchScheduleTeacher, setTeacherDate, setPageToggle, setJoinLoader, setCardData, fetchSubList, fetchClassList, fetchScheduleStats, fetchSummaryData } from 'actions/schedule'
import { DatePicker, Image, Typography, Select, Button, Tooltip, Row, Col, Spin } from 'antd'
import PageDataLoader from 'components/pageDataLoader'
// The same header component scheduleAdmin.js uses - NOT antd's PageHeader, which this
// page used to import. They are different components with different markup, which is why
// the admin header rules (.headerStyle, .r-jsb, .flex-1.display-flex in
// scheduleAdminDesign.css) had nothing to attach to here.
import PageHeader from 'components/pageHeader'
import moment from 'moment'
import RecordingsModal from 'pages/broadcast/localComponent/recordingsModal'
import React, { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import emptyImage from '../../Assets/schedule/Group 10647.svg'
import CancelledClassCard from './cancelledClassCard'
import CompletedClassCard from './completedClassCard'
import OngoingClassCard from './onGoingClassCard'
import ScheduleClassCard from './scheduledClass'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { EventRegister } from 'react-native-event-listeners'
import { InputSearch } from 'components/customInputs'
import dropdownArrow from '../../Assets/schedule/dropdownArrow.svg'
import calendarIcon from '../../Assets/schedule/calendar.svg'
// Imported for the filter-row sizing this page now shares with the admin bar - every
// other rule in there is scoped to .schedule-admin-page and cannot reach this page.
import './scheduleAdminDesign.css'
import scheduledIcon from '../../Assets/schedule/scheduledIcon.svg'
import ongoingIcon from '../../Assets/schedule/ongoingIcon.svg'
import completedIcon from '../../Assets/schedule/completedIcon.svg'
import cancelledIcon from '../../Assets/schedule/cancelledIcon.svg'
import ScheduleStatsCard from './ScheduleStatsCard'
import PieChartCard from './pieChartCard'
import BarGraphCard from './BarGraph'
import { Title } from 'components/Typography'
import { summariseOverviewResp, buildOverviewCards, summaryRangeFor, rangeForView } from './summaryStats'
const { Text } = Typography
const { Option } = Select;
const ScheduleTeacher = ({ fetchScheduleTeacher, scheduleList, fetchScheduleFilterTeacherandStudent, stdListFilter, subListFilter,
    getRecordings, setCompletedSubName, setTeacherDate, teacherDate, pageToggle, setPageToggle, setJoinLoader, setCardData,
    subList, classList, fetchSubList, fetchClassList, fetchScheduleStats, fetchSummaryData, summaryDataList, user }) => {
    const [pageLoader, togglePageLoader] = useState(false);
    const [isRecordingsModalVisible, setRecordingsModalVisibility] = useState(false);
    // const [date, setDate] = useState('')
    const [searchSub, setSearchSub] = useState([])
    const [std, setStd] = useState([])
    const [date, setDate] = useState(null);
    const [isBatchOpen, setIsBatchOpen] = useState(false);
    const [isSubOpen, setIsSubOpen] = useState(false);
    const [isDateHover, setIsDateHover] = useState(false);
    // Counts for the Overview row, from /schedule-new/summary-data - fetched by the
    // overviewRange effect below.
    const [overviewStats, setOverviewStats] = useState({ scheduled: 0, ongoing: 0, completed: 0, cancelled: 0 });
    // Month range the Overview cards cover, driven by the picker beside the "Overview"
    // label. Same state, same default (the current calendar month) and the same
    // full-month snapping as scheduleAdmin.js, so a teacher reads that row over the same
    // period an admin does.
    const [overviewRange, setOverviewRange] = useState([
        moment().startOf('month'),
        moment().endOf('month'),
    ]);
    const [todayStats, setTodayStats] = useState({ scheduled: 0, ongoing: 0, completed: 0, cancelled: 0 });
    // Week the Summary bar graph covers. Same fixed calendar buckets the admin dashboard
    // uses (1-7, 8-14, 15-21, 22-28, 29-end) rather than a rolling seven days, so the two
    // dashboards describe the same week as the same week.
    const [summaryRange, setSummaryRange] = useState(() => {
        const day = moment().date();
        if (day < 8) return [moment().date(1).startOf('day'), moment().date(7).endOf('day')];
        if (day < 15) return [moment().date(8).startOf('day'), moment().date(14).endOf('day')];
        if (day < 22) return [moment().date(15).startOf('day'), moment().date(21).endOf('day')];
        if (day < 29) return [moment().date(22).startOf('day'), moment().date(28).endOf('day')];
        return [moment().date(29).startOf('day'), moment().date(29).add(6, 'days').endOf('day')];
    });
    const [summaryLoading, setSummaryLoading] = useState(false);
    // Summary header pickers, mirroring the admin dashboard's. 'week' is the Days view
    // and 'month' the Months view - the value the endpoint takes as ?type=.
    const [summaryView, setSummaryView] = useState('week');
    const [summaryYear, setSummaryYear] = useState(moment().year());
    const [summaryMonth, setSummaryMonth] = useState(moment().month());
    // All three dropdowns are manually controlled so their custom suffix icon can drive
    // opening, which also means antd's own click-outside close never runs - hence the
    // explicit handler below. Same arrangement as scheduleAdmin.js.
    const [yearOpen, setYearOpen] = useState(false);
    const [monthOpen, setMonthOpen] = useState(false);
    const [viewOpen, setViewOpen] = useState(false);
    const summaryControlsRef = useRef(null);
    useEffect(() => {
        if (!yearOpen && !monthOpen && !viewOpen) return undefined;
        const handleClickOutside = (e) => {
            if (summaryControlsRef.current && !summaryControlsRef.current.contains(e.target)) {
                setYearOpen(false);
                setMonthOpen(false);
                setViewOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [yearOpen, monthOpen, viewOpen]);
    // Measures the "Schedule" title bar's real rendered height and publishes it as
    // --schedule-title-h on the page root, so the sticky filter row - which parks
    // directly beneath the sticky title - can offset its own `top` by exactly that
    // instead of a guessed pixel value. Survives breakpoints, font-loading reflow and
    // any future change to either bar's content. Same mechanism as scheduleAdmin.js.
    const titleBarRef = useRef(null);
    const pageRootRef = useRef(null);
    useEffect(() => {
        const titleEl = titleBarRef.current;
        const rootEl = pageRootRef.current;
        if (!titleEl || !rootEl) return undefined;
        const applyHeight = () => {
            rootEl.style.setProperty('--schedule-title-h', `${titleEl.offsetHeight}px`);
        };
        applyHeight();
        const observer = new ResizeObserver(applyHeight);
        observer.observe(titleEl);
        return () => observer.disconnect();
    }, []);
    const subSelectRef = useRef(null);
    const batchSelectRef = useRef(null);

    const derivedSubjects = React.useMemo(() => {
        return (subList && subList.length > 0) ? subList : [];
    }, [subList]);

    const derivedStandards = React.useMemo(() => {
        return (classList && classList.length > 0) ? classList : [];
    }, [classList]);

    const applyTodayStats = React.useCallback((resp) => {
        if (!resp) return;
        setTodayStats({
            scheduled: resp.scheduled?.length || 0,
            ongoing: resp.ongoing?.length || 0,
            completed: resp.completed?.length || 0,
            cancelled: resp.cancelled?.length || 0,
        });
    }, []);

    const refreshTodayStats = React.useCallback(() => {
        const today = moment().format('DD/MM/YYYY');
        fetchScheduleFilterTeacherandStudent(today, '', null, applyTodayStats, null, true);
    }, [fetchScheduleFilterTeacherandStudent, applyTodayStats]);

    const filterStateRef = useRef({ date, std, searchSub });
    filterStateRef.current = { date, std, searchSub };

    const apilistener = useRef(null);
    useEffect(() => {
        apilistener.current = EventRegister.addEventListener('apicall:scheduleHome', () => {
            const { date: currentDateFilter, std: currentStd, searchSub: currentSub } = filterStateRef.current;
            const targetDate = currentDateFilter || moment().format('DD/MM/YYYY');
            setTeacherDate('stringDate', targetDate);
            setDate(targetDate);
            togglePageLoader(true);
            const isToday = targetDate === moment().format('DD/MM/YYYY') && (!currentStd || currentStd.length === 0) && (!currentSub || currentSub.length === 0);
            fetchScheduleFilterTeacherandStudent(targetDate, '', currentStd, (resp) => {
                togglePageLoader(false);
                if (isToday) applyTodayStats(resp);
            }, currentSub);
            if (!isToday) {
                refreshTodayStats();
            }
        });
        return () => {
            EventRegister.removeEventListener(apilistener.current);
        };
    }, [refreshTodayStats, fetchScheduleFilterTeacherandStudent, setTeacherDate]);

    // Initial fetch of today's stats
    useEffect(() => {
        refreshTodayStats();
    }, [refreshTodayStats]);

    useEffect(() => {
        fetchSubList('')
        fetchClassList('', '')
        setJoinLoader(false)
        // The Overview counts are deliberately NOT fetched here - the overviewRange
        // effect below owns that request and runs on mount as well as on every range
        // change, so repeating it here would only duplicate the call on load.
        if (pageToggle == '1') {
            togglePageLoader(true)
            fetchScheduleTeacher(() => togglePageLoader(false))
            setTeacherDate('stringDate', moment().format('DD/MM/YYYY'))
        }
        else {
            togglePageLoader(true)
            fetchScheduleFilterTeacherandStudent(teacherDate?.date, searchSub, null, () => togglePageLoader(false))
            setPageToggle('1')
        }
    }, [])

    // useEffect(()=>{
    //     console.log('123456',teacherDate)
    // }, [teacherDate])

    const onChangeDate = (date, dateString) => {
        const nextDate = dateString || null;
        setDate(nextDate);
        setTeacherDate('stringDate', dateString || moment().format('DD/MM/YYYY'));
        togglePageLoader(true);
        fetchScheduleFilterTeacherandStudent(dateString, '', std, () => togglePageLoader(false), searchSub);
    }
    const onSearchSubject = (value) => {
        setSearchSub(value)
        togglePageLoader(true)
        fetchScheduleFilterTeacherandStudent(date, '', std, () => togglePageLoader(false), value)
    }

    const onchangeClass = (value) => {
        setStd(value)
        togglePageLoader(true)
        fetchScheduleFilterTeacherandStudent(date, '', value, () => togglePageLoader(false), searchSub)
    }
    const handleReplay = (streamId, subject, completedItem) => {
        setCardData(completedItem)
        setCompletedSubName(subject.name);
        getRecordings(streamId, () => {
            setRecordingsModalVisibility(true);
        });
    }
    const location = useLocation()
    const history = useHistory()

    useEffect(() => {
        if (history.location.state?.fromQuizSave) {
            // window.alert(`ScheduleTeacher detected fromQuizSave. scheduleId: ${history.location.state.scheduleId}`);
        }
    }, [history.location.state]);
    // Overview counts for the picked month range - the same request the admin dashboard's
    // overview cards make (type=month, compiled=true). Runs on mount and on every range
    // change, which is why the mount effect above no longer fetches these itself.
    //
    // The user guard is not defensive noise. ownScope tells fetchScheduleStats to add
    // teacherId, but withTeacherScope can only do that once session.user has an id
    // (actions/schedule.js) - fired before the session lands, the request goes out with no
    // teacherId at all and the endpoint answers with the whole organisation's counts, which
    // is precisely the wrong number to put on one teacher's dashboard. Waiting for the user
    // costs a render; not waiting costs correctness. user is in the deps for the same
    // reason, so the request is made again as soon as the session is there.
    //
    // scheduleList is a dep so the cards follow the classes: publishing, cancelling or
    // deleting a class refreshes the list through the apicall:scheduleHome listener above,
    // and the counts have to move with it rather than keep showing the pre-edit totals.
    // Same set of triggers the admin dashboard's overview effect uses.
    useEffect(() => {
        if (!user || Object.keys(user).length === 0) return;
        if (!overviewRange || overviewRange.length !== 2) return;
        fetchScheduleStats(
            overviewRange[0].format('YYYY-MM-DD'),
            overviewRange[1].format('YYYY-MM-DD'),
            (resp) => { if (resp) setOverviewStats(summariseOverviewResp(resp)) },
            // This page only ever shows the signed-in teacher's own classes, so it says
            // so rather than leaving the action to infer it from role strings.
            true
        );
    }, [overviewRange, user, scheduleList]);

    // Bar-graph data for the visible week, refetched whenever the week moves. The action
    // narrows it to this teacher by teacherId (withTeacherScope in actions/schedule.js),
    // so the bars are their own classes rather than the whole org's.
    useEffect(() => {
        if (!summaryRange || summaryRange.length !== 2) return;
        setSummaryLoading(true);
        fetchSummaryData(
            summaryView,
            summaryRange[0].format('YYYY-MM-DD'),
            summaryRange[1].format('YYYY-MM-DD'),
            () => setSummaryLoading(false),
            true
        );
    }, [summaryRange, summaryView]);

    const formattedSummaryRange = `${summaryRange[0].format('D MMM')} - ${summaryRange[1].format('D MMM')}`;

    const onSummaryYearChange = (year) => {
        setSummaryYear(year);
        setSummaryRange(summaryRangeFor(summaryView, year, summaryMonth, 'year'));
    };

    const onSummaryMonthChange = (month) => {
        setSummaryMonth(month);
        setSummaryRange(summaryRangeFor(summaryView, summaryYear, month, 'month'));
    };

    // Only sets state - the effect above owns the refetch, so switching view fires one
    // request rather than the two it would take to fetch here as well.
    const onSummaryViewChange = (view) => {
        if (view === 'week') {
            setSummaryYear(moment().year());
            setSummaryMonth(moment().month());
        }
        setSummaryRange(rangeForView(view, summaryYear));
        setSummaryView(view);
    };

    // Steps a whole week at a time, anchored to the edge of the current one, so the
    // buckets stay contiguous instead of drifting by a day on each press.
    const moveSummaryRange = (direction) => {
        let newStart, newEnd;
        if (direction === 1) {
            newStart = summaryRange[1].clone().add(1, 'day').startOf('day');
            newEnd = newStart.clone().add(6, 'days').endOf('day');
        } else {
            newEnd = summaryRange[0].clone().subtract(1, 'day').endOf('day');
            newStart = newEnd.clone().subtract(6, 'days').startOf('day');
        }
        setSummaryRange([newStart, newEnd]);
    };

    // The donut counts whatever day the card list below is showing. On landing that is
    // today, which is why the heading says so; once another date is picked the two have
    // to keep agreeing, so the heading follows the selection rather than claiming
    // "today" over another day's numbers.
    const selectedDay = date ? moment(date, 'DD/MM/YYYY') : moment();
    const isSelectedDayToday = selectedDay.isSame(moment(), 'day');
    const activitiesData = todayStats;

    // antd hands back the month a user clicked; the counts are read per whole month, so
    // both ends are widened to month boundaries before they reach the request. Clearing
    // the picker falls back to the current month rather than an empty range. Identical to
    // scheduleAdmin.js's handler.
    const onOverviewRangeChange = (dates) => {
        if (!dates) {
            setOverviewRange([
                moment().startOf('month'),
                moment().endOf('month'),
            ]);
            return;
        }
        const snappedStart = dates[0].clone().startOf('month');
        const snappedEnd = dates[1].clone().endOf('month');
        setOverviewRange([snappedStart, snappedEnd]);
    };

    // No clear affordance while the picker is already on its default month - there would
    // be nothing to clear back to.
    const isOverviewCurrentMonth = overviewRange && overviewRange[0] && overviewRange[1] &&
        overviewRange[0].isSame(moment().startOf('month'), 'day') &&
        overviewRange[1].isSame(moment().endOf('month'), 'day');

    // Same four cards, icons and colours as the admin dashboard's Overview row - one
    // component and one palette, built from the shared helper, so the two cannot drift.
    const statsData = buildOverviewCards(overviewStats, {
        scheduled: scheduledIcon,
        ongoing: ongoingIcon,
        completed: completedIcon,
        cancelled: cancelledIcon,
    });

    return (
        <div className="schedule-admin-page schedule-teacher-page" style={{ width: '100%' }} ref={pageRootRef}>
            {/* Title bar - markup copied from scheduleAdmin.js so the two headers are the
                same element tree and the same stylesheet rules land on both. Sticky at
                top: 0; its measured height feeds --schedule-title-h for the filter row
                below. The inner zIndex: 99 is what keeps the header content above the
                bar's own stacking context as the page scrolls under it. */}
            <div className="schedule-title-bar" ref={titleBarRef}>
                <div className="schedule-page-header" style={{ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', position: 'relative', zIndex: 99, backgroundColor: '#ffffff' }}>
                    <div style={{ marginTop: -10, minHeight: 50, width: '100%' }}>
                        <PageHeader
                            title='Schedule'
                            onBackPress={location?.state?.key ? () => { history.goBack(); } : undefined}
                        />
                    </div>
                </div>
            </div>
            {/* Everything below the sticky title scrolls as one block, the same shape
                scheduleAdmin.js uses. One static sibling rather than a run of loose
                siblings: the sticky bars then layer over a single subtree instead of
                interleaving with each section in turn. */}
            <div className="schedule-teacher-body">
                {/* Overview - this teacher's class counts for the month range the picker
                    beside the heading holds (the current month on landing), from
                    /schedule-new/summary-data (narrowed to them by teacherId; see
                    withTeacherScope in actions/schedule.js). Sits above the class lists and
                    renders independently of them: the counts cover whole months while the
                    lists below cover only the selected day, so a day with nothing on it still
                    has a summary worth reading. */}
                {/* .schedule-content owns the gap down to the charts, exactly as on the
                    admin dashboard: padding on the block holding the stat cards rather
                    than a margin on either Row. Padding never collapses and is out of
                    reach of antd's Row/Col gutter, which rewrites its own vertical
                    margins on a second render once its flex-gap probe resolves - a
                    margin here measures differently before and after that. */}
                <div className="schedule-content">
                    <div className="schedule-overview-header">
                        <Title className="overview-title">Overview</Title>

                        {/* Markup copied from scheduleAdmin.js so both dashboards get the
                            same control off the same .overview-range-picker rules - those
                            are scoped to .schedule-admin-page, which this page's root
                            carries alongside .schedule-teacher-page. */}
                        <DatePicker.RangePicker
                            value={overviewRange}
                            onChange={onOverviewRangeChange}
                            allowClear={!isOverviewCurrentMonth}
                            bordered={false}
                            inputReadOnly
                            format="MMM YYYY"
                            separator="-"
                            suffixIcon={
                                <img
                                    src={calendarIcon}
                                    alt="calendar"
                                    style={{ width: 24, height: 24 }}
                                />
                            }
                            picker="month"
                            className={`overview-range-picker ${!isOverviewCurrentMonth ? 'can-clear' : ''}`}
                            // antd 4 spells this dropdownClassName - popupClassName is the antd 5
                            // name and was silently ignored, so .overview-range-dropdown never
                            // reached the panel.
                            dropdownClassName="overview-range-dropdown"
                            // The panel has to live inside the scrolling content rather than in
                            // document.body. This app scrolls #mainBody (root/Layout.js puts
                            // overflow: scroll on it), not the window, and a popup parented to the
                            // body is aligned once against the trigger's viewport rect and never
                            // hears about that inner scroll - so it stayed where it opened while the
                            // page moved under it, ending up across the title bar and the stat
                            // cards. Parented to the picker's own row it is positioned against that
                            // row and travels with it; .schedule-overview-header carries the
                            // position: relative that makes the offsets resolve there.
                            getPopupContainer={(trigger) => trigger.parentElement || document.body}
                        />
                    </div>
                    <Row className="schedule-stats-row" gutter={16} style={{ rowGap: 16 }}>
                        {statsData.map((item, index) => (
                            <Col key={index} xs={24} sm={12} md={12} lg={6} xl={6}>
                                <ScheduleStatsCard {...item} />
                            </Col>
                        ))}
                    </Row>
                </div>

                {/* Donut + bar graph, the same two cards and column split the admin dashboard
                    runs. Both read this teacher's data only - the donut off the card list
                    already on screen, the bars off /schedule-new/summary-data with teacherId. */}
                <Row className="schedule-charts-row" gutter={16} align="stretch" style={{ marginTop: 0, marginBottom: 8, rowGap: 16 }}>
                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                        <div className="pieChartCard">
                            <Title>Today's activities</Title>
                            <div style={{ flex: 1, minHeight: 0 }}>
                                <PieChartCard activitiesData={activitiesData} />
                            </div>
                        </div>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                        <div className="barChartCard" style={{ display: 'flex', flexDirection: 'column' }}>
                            <div className="summary-header">
                                <div className="summary-left">
                                    <Title className="summary-title">Summary</Title>
                                </div>
                                <div className="summary-controls ScheduleTeacher-summary-controls" ref={summaryControlsRef}>
                                    {summaryView === 'week' && (
                                        <div className="range-pill" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <span className="arrow" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => moveSummaryRange(-1)}>
                                                <img src={dropdownArrow} alt="prev" style={{ width: 12, transform: 'rotate(90deg)' }} />
                                            </span>
                                            <span className="pill-text" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>{formattedSummaryRange}</span>
                                            <span className="arrow" style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => moveSummaryRange(1)}>
                                                <img src={dropdownArrow} alt="next" style={{ width: 12, transform: 'rotate(-90deg)' }} />
                                            </span>
                                        </div>
                                    )}

                                    {/* Year */}
                                    <Select
                                        bordered={false}
                                        value={summaryYear}
                                        className="summary-select"
                                        open={yearOpen}
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ minWidth: 100 }}
                                        getPopupContainer={() => summaryControlsRef.current || document.body}
                                        onDropdownVisibleChange={(open) => setYearOpen(open)}
                                        onChange={(val) => { onSummaryYearChange(val); setYearOpen(false); }}
                                        suffixIcon={
                                            <img
                                                src={dropdownArrow}
                                                alt="dropdown"
                                                className="summary-dropdown-icon"
                                                onMouseDown={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setYearOpen((prev) => !prev);
                                                    setMonthOpen(false);
                                                    setViewOpen(false);
                                                }}
                                            />
                                        }
                                    >
                                        {Array.from({ length: 10 }, (_, i) => 2020 + i).map((year) => (
                                            <Option key={year} value={year}>{year}</Option>
                                        ))}
                                    </Select>

                                    {/* Month - meaningless in the Months view, which spans a whole year */}
                                    {summaryView !== 'month' && (
                                        <Select
                                            bordered={false}
                                            value={summaryMonth}
                                            className="summary-select"
                                            open={monthOpen}
                                            dropdownMatchSelectWidth={false}
                                            dropdownStyle={{ minWidth: 140 }}
                                            getPopupContainer={() => summaryControlsRef.current || document.body}
                                            onDropdownVisibleChange={(open) => setMonthOpen(open)}
                                            onChange={(val) => { onSummaryMonthChange(val); setMonthOpen(false); }}
                                            suffixIcon={
                                                <img
                                                    src={dropdownArrow}
                                                    alt="dropdown"
                                                    className="summary-dropdown-icon"
                                                    onMouseDown={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setMonthOpen((prev) => !prev);
                                                        setYearOpen(false);
                                                        setViewOpen(false);
                                                    }}
                                                />
                                            }
                                        >
                                            {moment.months().map((m, i) => (
                                                <Option key={i} value={i}>{m}</Option>
                                            ))}
                                        </Select>
                                    )}

                                    {/* Days / Months */}
                                    <Select
                                        bordered={false}
                                        value={summaryView}
                                        className="summary-select"
                                        open={viewOpen}
                                        dropdownMatchSelectWidth={false}
                                        dropdownStyle={{ minWidth: 100 }}
                                        getPopupContainer={() => summaryControlsRef.current || document.body}
                                        onDropdownVisibleChange={(open) => setViewOpen(open)}
                                        onChange={(val) => { onSummaryViewChange(val); setViewOpen(false); }}
                                        suffixIcon={
                                            <img
                                                src={dropdownArrow}
                                                alt="dropdown"
                                                className="summary-dropdown-icon"
                                                onMouseDown={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setViewOpen((prev) => !prev);
                                                    setYearOpen(false);
                                                    setMonthOpen(false);
                                                }}
                                            />
                                        }
                                    >
                                        <Option value="week">Days</Option>
                                        <Option value="month">Months</Option>
                                    </Select>
                                </div>
                            </div>
                            <div style={{ flex: 1, minHeight: 0, position: 'relative' }}>
                                {summaryLoading && !pageLoader && (!summaryDataList || summaryDataList.length === 0) ? (
                                    <div style={{
                                        position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        zIndex: 10, background: 'rgba(255,255,255,0.7)'
                                    }}>
                                        <Spin size="large" />
                                    </div>
                                ) : null}
                                <BarGraphCard
                                    barGraphData={summaryDataList}
                                    year={summaryYear}
                                    view={summaryView}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                {/* Filters sit below the charts, as they do on the admin dashboard: the
                    Overview and Summary cover the whole month/week regardless of what is
                    filtered, so putting the controls above them would imply they drive those
                    numbers. They belong with the class list they actually filter. */}
                {/* Laid out on the same antd grid as the charts above - 6/24 then 18/24,
                    same gutter - so the date field lines up with the donut card and the two
                    selects together span exactly the Summary card. Percentage widths on a
                    plain flex row cannot land on those edges: the gutter's negative margins
                    move them by 8px, and the gap space-between distributes is whatever is
                    left over rather than the gutter. */}
                <Row className="ScheduleTeacher-datepicker-search" gutter={16} style={{ rowGap: 16 }}>
                    <Col xs={24} sm={24} md={12} lg={6} xl={6}>
                        <div className="schedule-date-pill" onMouseEnter={() => setIsDateHover(true)} onMouseLeave={() => setIsDateHover(false)} style={{ width: '100%', height: 40, display: 'flex', alignItems: 'center' }}>
                            <DatePicker
                                showToday
                                allowClear
                                onChange={onChangeDate}
                                value={date ? moment(date, 'DD/MM/YYYY') : moment(moment().format('DD/MM/YYYY'), 'DD/MM/YYYY')}
                                format="DD/MM/YYYY"
                                // Read-only so the field only accepts a real date via the calendar
                                // popup — otherwise it's a free-text input letters/specials can go into.
                                inputReadOnly
                                bordered={false}
                                dropdownClassName="rounded-date-dropdown"
                                getPopupContainer={() => document.querySelector('.ScheduleTeacher-datepicker-search') || document.body}
                                suffixIcon={
                                    <img src={calendarIcon} alt="calendar" className="schedule-calendar-icon" style={{ opacity: isDateHover ? 0 : 1, pointerEvents: isDateHover ? 'none' : 'auto', transition: 'opacity 0.15s ease' }} />
                                }
                                clearIcon={<span className="anticon anticon-close-circle"><svg viewBox="64 64 896 896" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z" /></svg></span>}
                                style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center' }}
                            />
                        </div>
                    </Col>

                    <Col xs={24} sm={24} md={12} lg={18} xl={18}>
                        <Row gutter={16} style={{ rowGap: 16 }}>
                            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                <Select
                                    mode="multiple"
                                    showSearch
                                    bordered={false}
                                    showArrow
                                    allowClear
                                    placeholder="Search by Subject"
                                    value={searchSub}
                                    open={isSubOpen}
                                    onDropdownVisibleChange={(open) => setIsSubOpen(open)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option?.children?.toString().toLowerCase().includes(input.toLowerCase())}
                                    onChange={onSearchSubject}
                                    onClear={() => {
                                        setIsSubOpen(false);
                                        if (subSelectRef.current) subSelectRef.current.blur();
                                    }}
                                    ref={subSelectRef}
                                    className="filter-control input-like-select"
                                    suffixIcon={
                                        <img src={dropdownArrow} alt="dropdown" className="dropdown-icon" onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setIsSubOpen((prev) => !prev); }} />
                                    }
                                    getPopupContainer={() => document.querySelector('.ScheduleTeacher-datepicker-search') || document.body}
                                    dropdownClassName="schedule-filter-select-dropdown"
                                    dropdownRender={(menu) => <div className="schedule-select-dropdown-inner">{menu}</div>}
                                    notFoundContent={<div style={{ textAlign: 'center', padding: '10px', color: '#AEAEAE' }}>No subject found</div>}
                                    loading={pageLoader}
                                    style={{ width: '100%', background: 'transparent', border: '1px solid #AEAEAE', borderRadius: 12 }}
                                >
                                    {derivedSubjects?.length != 0 ? derivedSubjects.map((item, index) => (
                                        <Option key={index} value={item.id} label={item.name}>{item.name}</Option>
                                    )) : null}
                                </Select>
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
                                <Select
                                    mode="multiple"
                                    showSearch
                                    bordered={false}
                                    showArrow
                                    allowClear
                                    placeholder="Search by batch"
                                    value={std}
                                    loading={pageLoader}
                                    open={isBatchOpen}
                                    onDropdownVisibleChange={(open) => setIsBatchOpen(open)}
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option?.children?.toString().toLowerCase().includes(input.toLowerCase())}
                                    onChange={onchangeClass}
                                    onClear={() => {
                                        setIsBatchOpen(false);
                                        if (batchSelectRef.current) batchSelectRef.current.blur();
                                    }}
                                    ref={batchSelectRef}
                                    className="filter-control input-like-select"
                                    suffixIcon={
                                        <img src={dropdownArrow} alt="dropdown" className="dropdown-icon" onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); setIsBatchOpen((prev) => !prev); }} />
                                    }
                                    getPopupContainer={() => document.querySelector('.ScheduleTeacher-datepicker-search') || document.body}
                                    dropdownClassName="schedule-filter-select-dropdown"
                                    dropdownRender={(menu) => <div className="schedule-select-dropdown-inner">{menu}</div>}
                                    notFoundContent={<div style={{ textAlign: 'center', padding: '10px', color: '#AEAEAE' }}>No batch found</div>}
                                    style={{ width: '100%', background: 'transparent', border: '1px solid #AEAEAE', borderRadius: 12 }}
                                >
                                    {derivedStandards?.length != 0 ? derivedStandards.map((item, index) => (
                                        <Option key={index} value={item.id} label={item.std ? (item.std + '-' + item.section) : item.name}>{item.std ? (item.std + '-' + item.section) : item.name}</Option>
                                    )) : null}
                                </Select>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                {scheduleList?.ongoing?.length === 0 && scheduleList?.scheduled?.length === 0 && scheduleList?.completed?.length === 0 && scheduleList?.cancelled?.length === 0 ?
                    <div className="ScheduleTeacherContentMain">
                        <div className="ScheduleTeacherContentEmpty">
                            <Image src={emptyImage} preview={false} />
                            <Text style={{ fontWeight: 'bold', fontSize: '18px', fontFamily: 'roboto' }}>No live classes scheduled!</Text>
                            {/* <Text style={{ color: "#636363", fontSize: '14px', fontFamily: 'roboto', textAlign: 'center', marginBottom: '8px' }}>There are no live classes scheduled yet.</Text> */}
                        </div>
                    </div> :
                    <div>
                        {scheduleList?.ongoing?.length != 0 ?
                            <div style={{ marginTop: '16px' }}>
                                <Text style={{ fontWeight: 'bold', fontSize: '18px' }}>Ongoing live classes</Text>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {scheduleList?.ongoing?.map((item) => (<OngoingClassCard key={item?.id || item?.occurrenceId} onGoingItem={item} togglePageLoader={togglePageLoader} pageLoader={pageLoader} />))}
                                </div>
                            </div>
                            : null}
                        {scheduleList?.scheduled?.length != 0 ?
                            <div style={{ marginTop: '16px' }}>
                                <Text style={{ fontWeight: 'bold', fontSize: '18px' }}>Schedule classes</Text>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {scheduleList?.scheduled?.map((item) => (<ScheduleClassCard key={item?.id || item?.occurrenceId} scheduleItem={item} togglePageLoader={togglePageLoader} pageLoader={pageLoader} />))}
                                </div>
                            </div>
                            : null}
                        {scheduleList?.completed?.length != 0 ?
                            <div style={{ marginTop: '16px' }}>
                                <Text style={{ fontWeight: 'bold', fontSize: '18px' }}>Completed classes</Text>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {scheduleList?.completed?.map((item) => (<CompletedClassCard key={item?.id || item?.occurrenceId} completedItem={item} handleReplay={handleReplay} togglePageLoader={togglePageLoader} pageLoader={pageLoader} />))}
                                </div>
                            </div>
                            : null}
                        {scheduleList?.cancelled?.length != 0 ?
                            <div style={{ marginTop: '16px' }}>
                                <Text style={{ fontWeight: 'bold', fontSize: '18px' }}>Cancelled classes</Text>
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                    {scheduleList?.cancelled?.map((item) => (<CancelledClassCard key={item?.id || item?.occurrenceId} cancelledItem={item} />))}
                                </div>
                            </div>
                            : null}
                    </div>

                }
                <PageDataLoader visible={pageLoader} />
                <RecordingsModal isRecordingsModalVisible={isRecordingsModalVisible}
                    setRecordingsModalVisibility={setRecordingsModalVisibility} />
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    const {
        scheduleList,
        stdListFilter,
        subListFilter,
        teacherDate,
        pageToggle,
        subList,
        classList,
        summaryDataList
    } = state.schedule;
    // The Overview request has to wait for this and be scoped by it - see the effect that
    // reads it. This page was not selecting it at all, so it had no way to know whether the
    // session was ready when it asked.
    const { user } = state.session;
    return {
        scheduleList,
        stdListFilter,
        subListFilter,
        teacherDate,
        pageToggle,
        subList,
        classList,
        summaryDataList,
        user
    };
};

const mapDispatchToProps = (dispatch) => ({
    fetchScheduleTeacher: (callback) => dispatch(fetchScheduleTeacher(callback)),
    fetchScheduleFilterTeacherandStudent: (...args) => dispatch(fetchScheduleFilterTeacherandStudent(...args)),
    getRecordings: (streamId, callback) => dispatch(getRecordings(streamId, callback)),
    setCompletedSubName: (name) => dispatch(setCompletedSubName(name)),
    setTeacherDate: (key, value) => dispatch(setTeacherDate(key, value)),
    setPageToggle: (value) => dispatch(setPageToggle(value)),
    setJoinLoader: (bool) => dispatch(setJoinLoader(bool)),
    setCardData: (val) => dispatch(setCardData(val)),
    fetchSubList: (search, callback) => dispatch(fetchSubList(search, callback)),
    fetchClassList: (search, subId, callback) => dispatch(fetchClassList(search, subId, callback)),
    fetchScheduleStats: (startDate, endDate, callback, ownScope) => dispatch(fetchScheduleStats(startDate, endDate, callback, ownScope)),
    fetchSummaryData: (type, startDate, endDate, callback, ownScope) => dispatch(fetchSummaryData(type, startDate, endDate, callback, ownScope))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps

)(ScheduleTeacher);
